module.exports = __webpack_public_path__ + "static/media/Group64.1f3e4b96.svg";